import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ErrorBoundary } from "./shared/pages/ErrorBoundary";
import { clientTheme } from "./theme/clientTheme";
import { startMockWorker } from "./demo/browser";

// Dynamically apply per-client branding to the document <head>
const { appName, faviconUrl } = clientTheme.branding;
document.title = appName;
if (faviconUrl) {
  (["icon", "apple-touch-icon"] as const).forEach((rel) => {
    const existing = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
    if (existing) {
      existing.href = faviconUrl;
      existing.type = faviconUrl.endsWith(".svg") ? "image/svg+xml" : "image/x-icon";
    } else {
      const link = document.createElement("link");
      link.rel = rel;
      link.href = faviconUrl;
      link.type = faviconUrl.endsWith(".svg") ? "image/svg+xml" : "image/x-icon";
      document.head.appendChild(link);
    }
  });
}

const renderApp = () => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
          <App />
        </LocalizationProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

startMockWorker().finally(renderApp);